<template>      
  <div>  
  <div class="krs019">
    <ul>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("message.RoleManage.001","권한아이디")}}</dt>
          <dd>
            <div class="txt">
              <div class="txt" style="padding : 7px;">{{ this.modalInfo.roleId }}</div>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear">
          <dt>{{$i18nUtil.trans("entity.todo.filter.expirationDate", "만료일")}}</dt>
          <dd>
            <div class="calendar_box_grp small">
              <div class="calendar_box" v-if="expireDate !== '9999-12-31'">
                <datepicker id="expiredDatePicker"
                  format="yyyy.MM.dd"
                  v-model="expireDate"
                ></datepicker>
              </div>
            </div>
            <div style="display:inline">
               <input type="checkbox" 
                  name="noExpireDate" 
                  id="noExpireDate"
                  :checked="expireDate === '9999-12-31'"
                  @change="checkNoExpireDate"
              /><label for="noExpireDate">만료일없음</label>
            </div>
          </dd>
        </dl>
      </li>
      <li>
        <dl class="clear" v-if="!this.modalInfo.userId">
          <dt>{{$i18nUtil.trans("message.RoleUserRegist.001","사용자명")}}</dt>
          <dd>
            <div class="txt">
              <input 
                    type="text" 
                    v-model="addUserNameList" :placeholder="$i18nUtil.trans('message.RoleUserRegist.003','사용자를 선택해 주세요.')"
                    style="background-color: white; color: black;"
                    disabled
              />
              <div class="error" v-if="userNameError" style="padding-right: 20px; float: right;">{{ $i18nUtil.trans("message.RoleUserRegist.003","사용자를 선택해 주세요.") }}</div>
            </div>
            <button
                  type="button"
                  class="btn-primary-small"
                  @click="addUser"
                  style="right: -110px; width: 111px;"
            >{{$i18nUtil.trans("message.RoleUserRegist.002","사용자 추가")}}
            </button>            
          </dd>
        </dl>
        <dl class="clear" v-if="this.modalInfo.userId">
          <dt>{{$i18nUtil.trans("message.RoleUserRegist.001","사용자명")}}</dt>
          <dd>
            <div class="txt">
              {{this.modalInfo.userName}}
            </div>   
          </dd>
        </dl>
      </li>
      <button v-if="this.modalInfo.expireDate === undefined"
              type="button"
              class="btn-primary-small black"
              @click="checkRegistData"
              style="float: right; margin-top: 10px;"
      >{{$i18nUtil.trans("button.save","저장")}}
      </button>
      <button v-if="this.modalInfo.expireDate !== undefined"
              type="button"
              class="btn-primary-small black"
              @click="modifyRoleUser"
              style="float: right; margin-top: 10px;"
      >{{$i18nUtil.trans("button.modify","수정")}}
      </button>
    </ul>
  </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    Dialog,
    Datepicker,
  },
  props: {
    modalInfo: {
      type: Object,
    },
  },
  data() {
    return {
      dBHeight: {
        "min-height": window.innerHeight - 151 + "px",
      },
      checkError: 0,
      userNameError: false,
      addUserIdList: [],
      addUserNameList: [],
      roleId: null,
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3500,
        },
      },
      expireDate: (this.modalInfo.expireDate === undefined || this.modalInfo.expireDate === '' || this.modalInfo.expireDate === null) ? new Date(this.$moment().add(3, "months")) : this.modalInfo.expireDate.substring(0, 10),
    };
  },  
  created() {
    EventBus.$off("returnUser");
    EventBus.$on("returnUser", param => {
      let obj = this;
      obj.returnUser(param);
      if(this.userNameError == true){
        this.userNameError = false
      }
    });
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showModal", "showToast"]),
    checkRegistData(){
      this.checkError = 1;
      if(this.addUserNameList == null || this.addUserNameList == undefined || this.addUserNameList.length == 0){
        this.userNameError = true;
        return;
      }else{
        this.userNameError = false;
      }      
        this.registRoleUser();
        this.checkError = 0;
    },
    registRoleUser() {
      let obj = this;
      
      let reqData = {};
      reqData.params = {
        roleId: this.modalInfo.roleId,
        addUserIdList: this.addUserIdList,
        expireDate: obj.$moment(this.expireDate).format("YYYYMMDD"),
      };
      reqData.url = "/api/org/role/registRoleUser";
      reqData.method = "post";

      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          }else {
            if(res.result.length > 0){ // 중복 사용자가 존재하면 0이상
              let duplUser = [];              
              res.result.forEach(element => {
                duplUser.push(element);
              });
              // addUserNameList(조직도에서 선택한 사용자)와 duplUser(이미 존재하는 사용자)의 length가 다르면, 중복되지 않은 사용자는 insert 되었으므로 emit 호출.
              if(this.addUserNameList.length != duplUser.length){
                obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.005","{user}은(는) 이미 존재하는 사용자입니다.",{user:duplUser})+" "+obj.$i18nUtil.trans("message.RoleUserRegist.006","{user}을(를) 제외한 사용자가 등록되었습니다.",{user:duplUser});
                obj.showToast(obj.toastInfo);
                EventBus.$emit("registRoleUser", {
                  regist : true,
                });
                this.addUserIdList = null;
                this.addUserNameList = null;
              }else{
                obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.005","{user}은(는) 이미 존재하는 사용자입니다.",{user:duplUser});
                obj.showToast(obj.toastInfo);
              }
            }else {
              obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.004","사용자가 등록되었습니다.");
              obj.showToast(obj.toastInfo);
              EventBus.$emit("registRoleUser", {
                regist : true,
              });
              this.addUserIdList = null;
              this.addUserNameList = null;
              // this.$emit("close");
            }
          }
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    modifyRoleUser() {
      let obj = this;
      
      let reqData = {};
      reqData.params = {
        roleId: this.modalInfo.roleId,
        userId: this.modalInfo.userId,
        expireDate: obj.$moment(this.expireDate).format("YYYYMMDD"),
      };
      reqData.url = "/api/org/role/modifyRoleUser";
      reqData.method = "post";
      
      //프로그레스바 시작
      this.showLoadingbar();
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then((res) => {
          //프로그레스바 종료
          this.hideLoadingbar();
          if (res.errorCode) {
            console.log(res.errorCode);
          }else {
            obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.007","수정 되었습니다.");
            obj.showToast(obj.toastInfo);
            EventBus.$emit("registRoleUser", {
              regist : true,
            });
            this.addUserIdList = null;
            this.addUserNameList = null;
          }
          this.$emit("close");
        })
        .catch((err) => {
          console.log("axios err => ", err);
        });
    },
    addUser() {
      let modalInfo = {};
        modalInfo = {
          title: this.$i18nUtil.trans("message.MultiOrg.001","조직도"),
          method: "post",
          width: "1050px",
          height: "780px",
          obj: this.$modal,          
          orgType: "MULTI_ORG",          
          component: MultiOrg,
          url: "/api/org/getDeptList",
          mode: "ROLE_USER",
        };      
      this.showModal(modalInfo);
    },
    returnUser(data){
      let obj = this;
      let users = data.users;
      if (users.length > 0) {
        obj.addUserNameList = [];
        obj.addUserIdList = [];
        for(var i=0; i<users.length; i++) {
          let userName = users[i].userName;
          let userId = users[i].userId;
          obj.addUserNameList.push(userName);
          obj.addUserIdList.push(userId);
        }
      }
    },
    checkNoExpireDate(event) {
      // 만료일 체크 시
      if (event.target.checked) {
        this.expireDate = "9999-12-31";
      } else {
        // unchecked이면 세달 뒤로 setting
        this.expireDate = new Date(this.$moment().add(3, "months"));
      }
    }
  },
};
</script>

<style scoped>
.krs019 > ul > li > dl > dt {
  width: 150px;
  padding-top: 5px;
}
.krs019 > ul > li > dl > dd {
  width: 900px;
}
.krs019 > ul > li > dl > dd > div > input {
  width: 80%;
  border: 1px solid #E6E6E8;
}
</style>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/RoleUserRegist.vue